module.exports = __webpack_public_path__ + "img/teachers-hjs.b705ac51.png";